import React, { useEffect, useState,  } from 'react'
import { Container, Row, Col, Button, Modal, Form, Tabs, Tab } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import useAuth from '../../../context/auth/useAuth'
import { Link } from 'react-router-dom'
import { addUser, getUsersByRole } from '../../../actions/usersActions'
import { CustomDataTable } from '../../../components/design/Datatables/CustomDataTable'
import Swal from 'sweetalert2'

export default function Users() { 
  	const { t } = useTranslation()
	const dispatch = useDispatch()
	const {client} = useAuth()

    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(25)
    const [search, setSearch] = useState('')
    const [searchAux, setSearchAux] = useState('')
    const [totalRows, setTotalRows] = useState(0)

	const {kitchenUsers, clients, resultuser, totalKitchen, totalClients} = useSelector(state=>state.users)

    const [modalShow, setModalShow] = useState(false)
    const [newKitchen, setNewKitchen] = useState({})
    const [isRegistering, setIsRegistering] = useState(false)
    const [isCorrect, setIsCorrect] = useState("")
    const [passwordverify, setPasswordverify] = useState("")

    const [showPasswordOne, setShowPasswordOne] = useState(false)
    const [showPasswordTwo, setShowPasswordTwo] = useState(false)

    const handlePasswordVisibilityOne = () => {
        setShowPasswordOne(!showPasswordOne)
    }

    const handlePasswordVisibilityTwo = () => {
        setShowPasswordTwo(!showPasswordTwo)
    }

	useEffect(() => {
		if(client){
			dispatch(getUsersByRole('Kitchen'))
            dispatch(getUsersByRole('Client', page, limit, search))
		}
	},[dispatch, t, client])

    useEffect(() => {
        if (client) {
            dispatch(getUsersByRole('Client', page, limit, search))
        }
    }, [page, limit, search])

    const openModal = () =>{
        setNewKitchen({
            firstname: '',
            phone: '',
            birthday: '',
            email: '',
            password: '',
            role: 'Kitchen',
        })
        setModalShow(true)
    }

    const handleInputChange = ({target})=>{
        setNewKitchen({
            ...newKitchen,
            [target.name]: target.value
        })
    }

    const checkValidation = (isPassVer, e) => {
        const confirmPass = e.target.value

        if(isPassVer){
            setPasswordverify(confirmPass)
        }else{
            setNewKitchen({
                ...newKitchen,
                'password': confirmPass
            })
        }

        if (newKitchen.password !== passwordverify) {
            setIsCorrect("Las contraseñas no coinciden")
        }else {
            setIsCorrect("")
        }
    }

    const handleAdd = async(e) => {
        e.preventDefault()
        setIsRegistering(true)
        if(isCorrect){
            if(newKitchen.password.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{6,15}$/g)){
                dispatch(addUser(newKitchen))
            }else{
                Swal.fire({
                    showConfirmButton: true,
                    confirmButtonText: t('global.great'),
                    icon: 'warning',
                    text: t('users.passwordsnotvalid')
                })
            }
        }else{
            Swal.fire({
                showConfirmButton: true,
                confirmButtonText: t('global.great'),
                icon: 'warning',
                text: t('users.passwordsnotmatch')
            })
        }
        setIsRegistering(false)
    }

    useEffect(() => {
        if(resultuser){
            switch (resultuser) {
                case 'success':
                    dispatch(getUsersByRole('Kitchen'))
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('users.useradd')
                    }).then(() => {
                        setModalShow(false)
                    })
                    break;
                case 'email':
                    Swal.fire({
                        showConfirmButton: true,
                        confirmButtonText: t('global.great'),
                        icon: 'warning',
                        text: t('users.emailduplicate')
                    })
                    break;
                default:
                    break;
            }
        }
    // eslint-disable-next-line
    }, [resultuser])

	const columnsKitchens = [
		{
			name: t('admin.users.name'),
			cell: user =>
				<div>
					{user.firstname}
				</div>,
			selector: (user) => user.firstname,
			sortable: true,
		},{
			name: t('admin.users.email'),
			cell: user =>
				<div>
					{user.email}
				</div>,
			selector: (user) => user.email,
			sortable: true,
		},{
            name: t('admin.users.restaurant'),
            cell: user =>
                <div>
                    {user?.restaurant?.name}
                </div>,
            selector: (user) => user?.restaurant?.name,
            sortable: true,
        },{
			name: t('admin.users.active'),
			cell: user =>
				<div>
                    {user.active
						?
							<img src="../images/check.svg" alt="check" width={25}></img>
						:
                            <img src="../images/times.svg" alt="times" width={25}></img>
					}
				</div>,
			selector: (user) => user.active,
			sortable: true,
		},{
			name: t('admin.users.profile'),
			cell: user =>
				<div>
					<Link to={`/admin/users/${user._id}`}>
						{t('admin.users.see')}
					</Link>
				</div>,
			sortable: false,
		}
	]

	const columnsClients = [
		{
			name: t('admin.users.name'),
			cell: user =>
				<div>
					{user.firstname}
				</div>,
			selector: (user) => user.firstname,
			sortable: true,
		},{
			name: t('admin.users.email'),
			cell: user =>
				<div>
					{user.email}
				</div>,
			selector: (user) => user.email,
			sortable: true,
		},{
			name: t('admin.users.active'),
			cell: user =>
				<div>
                    {user.active
						?
                            <img src="../images/check.svg" alt="check" width={25}></img>
                        :
                            <img src="../images/times.svg" alt="times" width={25}></img>
					}
				</div>,
			selector: (user) => user.active,
			sortable: true,
		},{
			name: t('admin.users.orders'),
			cell: user =>
				<div>
					<Link to={`/admin/userorders/${user._id}`}>
						{t('admin.users.orders')}
					</Link>
				</div>,
			sortable: false,
		},{
			name: t('admin.users.profile'),
			cell: user =>
				<div>
					<Link to={`/admin/users/${user._id}`}>
						{t('admin.users.see')}
					</Link>
				</div>,
			sortable: false,
		}
	]

	return (
        <Container className='p-5'>
            <Row className="mb-3">
                <Col xs={2} className='p-0'>
                    <Link className="p-0 my-3" to="/admin/dashboard">
                        <img src="../images/arrow-back.svg" alt="arrow-back" width={25}></img>
                    </Link>
                </Col>
                <Col xs={8} className='text-center'>
                    <h1 className='fs-18'>{t('admin.users.users')}</h1>
                </Col>
                <Col xs={2}></Col>
            </Row>
            <Row className="mt-5 mb-4">
                <Button variant='primary' type="submit" className="btn-primary my-2 button-withicon" onClick={() => openModal()}>
                    <i className="fa fa-user" aria-hidden="true"></i>
                    <label className='label-button'>{t('admin.users.createkitchenuser')}</label>
                </Button>
            </Row>

            <Row className="mt-4">
                <div className="tabs-card">
                    <Tabs
                        defaultActiveKey="kitchen"
                        id="users-tabs"
                        className="custom-tabs"
                    >
                        {/* TAB KITCHEN */}
                        <Tab eventKey="kitchen" title={t('admin.users.userskitchenlist')}>
                            <Row className="mt-4">
                                {kitchenUsers?.length > 0 ? (
                                    <CustomDataTable
                                        columns={columnsKitchens}
                                        data={kitchenUsers}
                                        pagination
                                        paginationServer
                                        paginationTotalRows={totalKitchen}
                                        onChangeRowsPerPage={(newLimit) => {
                                            setLimit(newLimit)
                                            setPage(1)
                                        }}
                                        onChangePage={(newPage) => {
                                            setPage(newPage)
                                        }}
                                    />
                                ) : (
                                    <h4 className='mt-4'>{t('admin.users.thereisnotkitchens')}</h4>
                                )}
                            </Row>
                        </Tab>

                        {/* TAB CLIENTS */}
                        <Tab eventKey="clients" title={t('admin.users.usersclientlist')}>
                            <Row className="mt-4">

                                <div className="d-flex my-2">
                                    <input
                                        type="text"
                                        className="form-control me-2"
                                        placeholder={t("datatables.buscar")}
                                        value={searchAux || ""}
                                        onChange={e => {
                                            setSearchAux(e.target.value)
                                            setPage(1)
                                        }}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                setSearch(searchAux)
                                                setPage(1)
                                            }
                                        }}
                                    />
                                    <Button onClick={() => setSearch(searchAux)}>
                                        <i className='fas fa-search'></i>
                                    </Button>
                                </div>

                                {clients?.length > 0 ? (
                                    <CustomDataTable
                                        columns={columnsClients}
                                        data={clients}
                                        pagination
                                        paginationServer
                                        paginationTotalRows={totalClients}
                                        onChangeRowsPerPage={(newLimit) => {
                                            setLimit(newLimit)
                                            setPage(1)
                                        }}
                                        onChangePage={(newPage) => {
                                            setPage(newPage)
                                        }}
                                    />
                                ) : (
                                    <h4 className='mt-4'>{t('admin.users.thereisnotclients')}</h4>
                                )}
                            </Row>
                        </Tab>
                    </Tabs>
                </div>
            </Row>
            <Modal show={modalShow} className="sd-modal" aria-labelledby="contained-modal-title-vcenter" centered>
                <Modal.Header>
                    <Modal.Title id="contained-modal-title-vcenter"></Modal.Title>
                    <i className='fa fa-times' onClick={() => setModalShow(false)}></i>
                </Modal.Header>
                <Modal.Body>
                    <label className='sd-label-create'>{t('admin.users.createkitchenuser')}</label>
                    <Form className="px-4 formulario" onSubmit={handleAdd}>
                        <Row className="text-center my-3">
                            <h2 className="sd-label text-start fs-16 fw-400">{t('admin.users.name')}*</h2>
                            <Form.Control
                                className="sd-input"
                                type='text'
                                name='firstname' 
                                value={newKitchen.firstname ||  ''}
                                placeholder={t('admin.users.setname')}
                                onChange={handleInputChange}
                                required
                            />
                        </Row>
                        <Row className="text-center my-3">
                            <h2 className="sd-label text-start fs-16 fw-400">{t('users.email')}*</h2>
                            <Form.Control
                                className="sd-input"
                                type='email'
                                name='email' 
                                value={newKitchen.email || ''}
                                placeholder={t('admin.users.setemail')}
                                onChange={handleInputChange}
                                required
                            />
                        </Row>
                        <Row className="text-center mt-3">
                            <h2 className="sd-label text-start fs-16 fw-400">{t('users.password')}</h2>
                        </Row>
                        <Row className="text-center mb-3 row-eye">
                            <Form.Control
                                className="sd-input"
                                type={showPasswordOne ? 'text' : 'password'}
                                name='password' 
                                value={newKitchen.password ||  ''}
                                placeholder={t('admin.users.setpassword')}
                                onChange={(e) => checkValidation(false, e)}
                                required
                            />
                            <img className="sd-imageneye" src={showPasswordOne ? "../../images/eyeclose.svg" : "../../images/eyeopen.svg"} alt="eyes" width={15} onClick={handlePasswordVisibilityOne}></img>
                        </Row>
                        <Row className="my-3">
                            <p>
                                <span className='password-list'>
                                    <span className='fs-12 fw-400'><b>·</b> {t('users.passwordneed2')}</span>
                                    <span className='fs-12 fw-400'><b>·</b> {t('users.passwordneed3')}</span>
                                    <span className='fs-12 fw-400'><b>·</b> {t('users.passwordneed4')}</span>
                                </span>
                            </p>
                        </Row>
                        <Row className='text-center mt-3'>
                            <h2 className="sd-label text-start">{t('users.passwordconfirm')}</h2>
                        </Row>
                        <Row className="text-center mb-3 row-eye">
                            <Form.Control
                                className="sd-input"
                                type={showPasswordTwo ? 'text' : 'password'}
                                name='passwordcheck'
                                placeholder={t('admin.users.setpasswordconfirm')}
                                onChange={(e) => checkValidation(true, e)}
                                required
                            />
                            <img className="sd-imageneye" src={showPasswordTwo ? "../../images/eyeclose.svg" : "../../images/eyeopen.svg"} alt="eyes" width={15} onClick={handlePasswordVisibilityTwo}></img>
                        </Row>
                        <Row className="text-center my-3">
                            <Col>
                                <Button variant='primary' type="submit" className="btn-primary w-100 my-2">
                                {isRegistering
                                    ?
                                        <>
                                            <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                        </>
                                    :
                                        <>{t('users.register')}</>
                                }
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                </Modal.Body>
            </Modal>
        </Container>
	)
}